enum TicketOrigin {
    Simec = "Simec",
    Customer = "Customer", 
    MySimecApp = "MySimecApp",
    Email = "Email"
}

export default TicketOrigin;